import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import type { TApiGenericError } from "../../timenotes-query/timenotes-query.types"
import { useCurrentUserQuery } from "../../users-accounts/queries/use-current-user-query"

interface Props {
  projectId: string
}

interface Args {
  taskId: string
  content: string
}

export function useCreateCommentMutation(props: Props) {
  const {
    projectId,
  } = props

  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const mutation = useMutation<{}, TApiGenericError<any>, Args>(
    ["create-comment"],
    async (params: Args) => {
      const { 
        taskId,
        content
      } = params

      const response = await apiClient.createComment({
        projectId,
        taskId,
        content
      })

      if (!response.ok) {
        throw response.errors
      }

      return { comment: response }
    },
    {
      onMutate: async (variables) => {
        /*
        TODO: not worth due to extra current user getting 

        const prevState = queryClient.getQueryData([
          "project-task",
          projectId,
          variables.taskId,
        ])

        const newComment = {
          id: 'PENDING',
          taskId: variables.taskId,
          content: variables.content,
        }

        queryClient.setQueryData(
          ["project-task", projectId, variables.taskId],
          (data: any) => {
            return {
              task: {
                ...data?.task,
                comments: [
                  newComment,
                  ,...data.task.comments
                ]
              }
            }
          }
        )
        return prevState
        */
      },
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["project-sections", projectId])
        queryClient.invalidateQueries(["project-task", projectId, variables.taskId])
      },
    }
  )

  return mutation
}
